<router-outlet></router-outlet>
<ngx-spinner type="ball-spin-clockwise" color="#FFEB3A"></ngx-spinner>
